var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorMsgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 47,
    viewBox: "0 0 46 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 23.5C3 12.4543 11.9543 3.5 23 3.5C34.0457 3.5 43 12.4543 43 23.5C43 34.5457 34.0457 43.5 23 43.5C11.9543 43.5 3 34.5457 3 23.5Z",
    fill: "#FEE4E2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0001 20.1665V23.4998M23.0001 26.8332H23.0084M31.3334 23.4998C31.3334 28.1022 27.6025 31.8332 23.0001 31.8332C18.3977 31.8332 14.6667 28.1022 14.6667 23.4998C14.6667 18.8975 18.3977 15.1665 23.0001 15.1665C27.6025 15.1665 31.3334 18.8975 31.3334 23.4998Z",
    stroke: "#D92D20",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23 40.5C13.6112 40.5 6 32.8888 6 23.5H0C0 36.2025 10.2975 46.5 23 46.5V40.5ZM40 23.5C40 32.8888 32.3888 40.5 23 40.5V46.5C35.7025 46.5 46 36.2025 46 23.5H40ZM23 6.5C32.3888 6.5 40 14.1112 40 23.5H46C46 10.7975 35.7025 0.5 23 0.5V6.5ZM23 0.5C10.2975 0.5 0 10.7975 0 23.5H6C6 14.1112 13.6112 6.5 23 6.5V0.5Z",
    fill: "#FEF3F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorMsgIcon);
export default __webpack_public_path__ + "static/media/error-msg-icon.b906316b7df0b1e378602a26737d0d0d.svg";
export { ForwardRef as ReactComponent };